import { Routes, Route, Navigate } from "react-router-dom";
import { SignedIn, SignedOut, RedirectToSignIn } from "@clerk/clerk-react";
import { AppLayout } from "@/components/layout/app-layout";
import { DashboardPage } from "@/routes/dashboard";
import { CampaignsPage } from "@/routes/campaigns";
import { CampaignDetailPage } from "@/routes/campaign-detail";
import { ExperimentsPage } from "@/routes/experiments";
import { ExperimentDetailPage } from "@/routes/experiment-detail";
import { EnginesPage } from "@/routes/engines";
import { RungsPage } from "@/routes/rungs";
import { CeilingPage } from "@/routes/ceiling";
import { JournalPage } from "@/routes/journal";
import { JournalDetailPage } from "@/routes/journal-detail";
import { SignInPage } from "@/routes/sign-in";
import { SignUpPage } from "@/routes/sign-up";

export function App() {
  return (
    <Routes>
      {/* Public auth routes */}
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />

      {/* Authed routes */}
      <Route
        element={
          <>
            <SignedIn>
              <AppLayout />
            </SignedIn>
            <SignedOut>
              <RedirectToSignIn />
            </SignedOut>
          </>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/campaigns" element={<CampaignsPage />} />
        <Route path="/campaigns/:id" element={<CampaignDetailPage />} />
        <Route path="/experiments" element={<ExperimentsPage />} />
        <Route path="/experiments/:id" element={<ExperimentDetailPage />} />
        <Route path="/engines" element={<EnginesPage />} />
        <Route path="/rungs" element={<RungsPage />} />
        <Route path="/ceiling" element={<CeilingPage />} />
        <Route path="/journal" element={<JournalPage />} />
        <Route path="/journal/:id" element={<JournalDetailPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
